import React from 'react'
import {
  FormControl,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  makeStyles
} from '@material-ui/core'
import { useField } from 'formik'

const CustomCheckboxField = ({ name, label, ...props }) => {
  const classes = useStyles()
  const [field, meta, helpers] = useField({ name, type: 'checkbox' })
  const { setValue } = helpers
  const errorText = meta.error && meta.touched ? meta.error : ''

  const handleChange = (event) => {
    setValue(event.target.checked)
  }

  return (
    <FormControl error={!!errorText} className={classes.formControl}>
      <FormControlLabel
        control={
          <Checkbox checked={field.value} onChange={handleChange} color="primary" {...props} />
        }
        label={label}
      />
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  )
}

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: theme.spacing(2)
  }
}))

export default CustomCheckboxField
